import { useMutation } from "react-query";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

import { deleteEmployeRequests } from "../../../../../MyApi/hr/employerequests";






const SingleEmployeRequests = ({ requests, classes ,refetch}) => {
  const { id,request , note, date_to ,date_from,employe, status} = requests;
  const navigate = useNavigate()
  const mutation = useMutation(["deleteemployerequest" , id] , ()=>deleteEmployeRequests(id),{
    onSuccess:(data)=>{
  toast.success(`${data.message}`)
  refetch()
    },onError:(error)=>{
      toast.error(`${error.response.data.message}`)
    }
  }
  )

  const deletePost =()=>{

 mutation.mutate()
  }


  return (   
    <tr>
      <td className={classes.idTable}>{id}</td>
      <td>{request}</td> 
      <td>  {employe}    </td>
       <td>{note}</td>
      <td> {date_to}-{date_from} </td>  
      <td>{status}</td>
     
      <td>
        <div>
          <div role="group" class="btn-group">
            <button
              class="btn btn-success"
              onClick={() =>
                navigate(`${process.env.PUBLIC_URL}/employerequests/${id}`)
              }>
              <i class="fa fa-eye"></i>
            </button>
            {/* <button
              class="btn btn-secondary"  
              onClick={() =>
                navigate(`${process.env.PUBLIC_URL}/employmentrequestsupdate/${id}`)
              }>
              <EditPen />
            </button> */}
            <button class="btn btn-danger" onClick={deletePost}>
              <i class="fa fa-trash"></i>
            </button>
          </div>
        </div>
      </td>
    </tr>
  );
};

export default SingleEmployeRequests;
